module.exports = __webpack_public_path__ + "media/images/sp/brands/eight/store_nagoyaekimae-d3b19f9525868194bcebb494fc7af738.jpg";